import { render, staticRenderFns } from "./UserPost.vue?vue&type=template&id=2e44e737&scoped=true&"
import script from "./UserPost.vue?vue&type=script&lang=js&"
export * from "./UserPost.vue?vue&type=script&lang=js&"
import style0 from "./UserPost.vue?vue&type=style&index=0&id=2e44e737&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e44e737",
  null
  
)

export default component.exports